import { Partial } from '@40seas/entities/common';
import { Quote } from './quote.entity';

export class UpdateQuoteDto extends Partial(Quote) {}
